import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";
import * as Connection from "../utils/Connections";
import $ from "jquery";
class LoginUserStore extends EventEmitter {
    constructor() {
        super();
        this.userData='';
        this.token='';
        this.loggedIn=false;

    }

    getProfileData(){
        return this.profile;
    }
    getLogged(){
        return this.loggedIn;
    }

    handleActions(action) {
        switch (action.type) {

            case "RECEIVE_LOGIN_SUCCESSFUL":
            {
                this.userData=action.loginData;
                this.loggedIn=true;
                this.token=this.userData.token;
                this.emit("change");
                break
            }
            case "RECEIVE_LOGIN_UNSUCCESSFUL":{
                this.userData=null;
                break;
            }
        }
    }

}

const loginUserStore = new LoginUserStore;
dispatcher.register(loginUserStore.handleActions.bind(loginUserStore));

export default loginUserStore;



// WEBPACK FOOTER //
// ./src/stores/LoginUserStore.js